export enum QuestNarrativeTypes {
	CHARACTER = "CHARACTER",
	SPLASH = "SPLASH",
}

export enum BackgroundImage {
	QUEST_BG_ART_1 = "quest_bg_art_1",
	QUEST_BG_ART_2 = "quest_bg_art_2",
	QUEST_BG_ART_3 = "quest_bg_art_3",
	QUEST_BG_ART_4 = "quest_bg_art_4",
	QUEST_BG_ART_5 = "quest_bg_art_5",
	QUEST_BG_ART_6 = "quest_bg_art_6",
	QUEST_BG_ART_7 = "quest_bg_art_7",
	QUEST_BG_ART_8 = "quest_bg_art_8",
	QUEST_BG_ART_9 = "quest_bg_art_9",
	QUEST_BG_ART_10 = "quest_bg_art_10",
	QUEST_BG_ART_11 = "quest_bg_art_11",
	QUEST_BG_ART_12 = "quest_bg_art_12",
	QUEST_BG_ART_13 = "quest_bg_art_13",
	QUEST_BG_ART_14 = "quest_bg_art_14",
	QUEST_BG_ART_15 = "quest_bg_art_15",
	QUEST_BG_ART_16 = "quest_bg_art_16",
	QUEST_BG_ART_17 = "quest_bg_art_17",
	QUEST_BG_ART_18 = "quest_bg_art_18",
	QUEST_BG_ART_19 = "quest_bg_art_19",
	QUEST_BG_ART_20 = "quest_bg_art_20",
	QUEST_BG_ART_21 = "quest_bg_art_21",
	QUEST_BG_ART_22 = "quest_bg_art_22",
	QUEST_BG_ART_25 = "quest_bg_art_25",
	QUEST_BG_ART_27 = "quest_bg_art_27",
	QUEST_BG_ART_29 = "quest_bg_art_29",
	QUEST_BG_ART_30 = "quest_bg_art_30",
	QUEST_BG_ART_35 = "quest_bg_art_35",
	QUEST_BG_ART_37 = "quest_bg_art_37",
	QUEST_BG_ART_47 = "quest_bg_art_47",
	QUEST_BG_ART_51 = "quest_bg_art_51",
	QUEST_BG_ART_54 = "quest_bg_art_54",
	QUEST_BG_ART_56 = "quest_bg_art_56",
	QUEST_BG_ART_57 = "quest_bg_art_57",
	QUEST_BG_ART_69 = "quest_bg_art_69",
	QUEST_BG_ART_80 = "quest_bg_art_80",
	QUEST_BG_ART_82 = "quest_bg_art_82",
	QUEST_BG_ART_83 = "quest_bg_art_83",
	QUEST_BG_ART_84 = "quest_bg_art_84",
	QUEST_BG_ART_86 = "quest_bg_art_86",
	QUEST_BG_ART_92 = "quest_bg_art_92",
	QUEST_BG_ART_93 = "quest_bg_art_93",
	QUEST_BG_ART_101 = "quest_bg_art_101",
	QUEST_BG_ART_PLAGUE_2 = "quest_bg_art_plague_2",
	QUEST_BG_ART_PLAGUE_7 = "quest_bg_art_plague_7",
}
